import { useController, UseFormReturn } from 'react-hook-form';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { AutocompleteTextFieldProps } from '../../../../../../react-commons/components/form/inputs/Form_ReferenceInput';
import React from 'react';
import { Controlled_VideoAttachmentTextField } from './Controlled_VideoAttachmentTextField';

export const Form_VideoAttachmentTextField = <T extends object, N extends boolean>({
                                                                                       projectVersionId,
                                                                                       name,
                                                                                       form,
                                                                                       propertyValidationInformation,
                                                                                       readOnly,
                                                                                   }: {
    projectVersionId: string | undefined | null;
    form: UseFormReturn<T>;
    propertyValidationInformation: PropertyValidationInformation;
    readOnly: boolean;
} & AutocompleteTextFieldProps<T, N>) => {
    const {
        field: {value, onChange: valueOnChange},
    } = useController({
        control: form.control,
        name,
    });

    return (
        <Controlled_VideoAttachmentTextField
            objectId={value} // TODO should be called value everywhere
            projectVersionId={projectVersionId}
            onChange={valueOnChange}
            readOnly={readOnly}
            propertyValidationInformation={propertyValidationInformation}
        />
    );
};
